/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_common_delete = /** @type {(inputs: {}) => string} */ () => {
	return `Eliminar`
};

const en_common_delete = /** @type {(inputs: {}) => string} */ () => {
	return `Delete`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const common_delete = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.common_delete(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("common_delete", locale)
	if (locale === "es") return es_common_delete(inputs)
	return en_common_delete(inputs)
};
export { common_delete as "common.delete" }